var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextmark = function SvgTextmark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66669 8.16663H16.3334V10.8333H15.6667V8.83329H12.3334V16.1666H14.3334V16.8333H9.33335V16.1666H11.6667V8.83329H8.33335V10.8333H7.66669V8.16663Z",
    fill: "var(--iconColor, currentColor)",
    stroke: "var(--iconColor, currentColor)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.38794,
    y: 4.9231,
    width: 2,
    height: 15.7814,
    fill: "var(--iconColor, currentColor)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.38794,
    y: 20.0573,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.38794,
    y: 2.9231,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3879,
    y: 4.9231,
    width: 2,
    height: 15.7814,
    fill: "var(--iconColor, currentColor)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9521,
    y: 20.067,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9521,
    y: 2.93298,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextmark);
export { ForwardRef as ReactComponent };